import { AnyFunction } from "@kraaft/helper-types";

export function executeAfterStatePropagation(fn: AnyFunction | undefined) {
  if (fn === undefined) {
    return;
  }
  setTimeout(fn, 0);
}
